<template>
  <ExhibitionContainer
    :ble-id="label_id"
    :asset-id="asset_id"
    :token="t"
    :form-id="hubspotIds.formId"
    :portal-id="hubspotIds.portalId"
    :region="hubspotIds.region"
    :asset-name-constructor="constructAssetName"
  >
    <template slot="banner">
      <Banner />
    </template>
  </ExhibitionContainer>
</template>
<script>
import ExhibitionContainer from '../../components/organisms/exhibitions/exhibition-container';
import Banner from '../../components/molecules/exhibitions/sato-partner-day-2026-banner';

export default {
  name: 'SatoPartnerDay2026',
  components: {
    ExhibitionContainer,
    Banner,

  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    label_id: { type: String, required: true },
    // eslint-disable-next-line vue/prop-name-casing
    asset_id: { type: String, required: true },
    t: { type: String, default: '' },
  },
  computed: {
    hubspotIds() {
      return {
        formId: '4284c2e0-eb74-4eb9-a017-e2d53bbcdd3a',
        portalId: '27004227',
        region: process.env.VUE_APP_HUBSPOT_REGION,
      };
    },
  },
  methods: {
    constructAssetName(formData) {
      // if (!formData || !formData.firstname || !formData.company) {
      if (!formData || !formData.firstname || !formData['0-2/name']) {
        throw new Error('Form data is missing required fields: firstname and company');
      }
      return `${formData.firstname} (${formData['0-2/name']})`;
    },
  },
};
</script>
